import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { LanguageMenuComponent } from '@app/pages/home/language-menu/language-menu.component';
import { AppState } from '@app/store/states/app.state';
import { TranslocoPipe } from '@jsverse/transloco';
import { LoadingService } from '@shared/services/loading.service';
import { ToastService } from '@shared/services/toast.service';
import { validateEmail } from '@shared/utils/validators';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [
    TranslocoPipe,
    ReactiveFormsModule,
    MatCardContent,
    MatCard,
    MatFormField,
    MatIcon,
    MatLabel,
    MatInput,
    MatButton,
    LanguageMenuComponent
  ],
  standalone: true
})
export class LoginComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly appState = inject(AppState);
  private readonly authService = inject(AuthService);
  private readonly loadingService = inject(LoadingService);
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);
  loginForm: FormGroup;

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, validateEmail()])
    });
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.loadingService.show();
      const email = this.loginForm.get('email').value;

      this.authService
        .initiateLogin(email)
        .pipe(
          tap(() => {
            this.appState.accountEmail = email;
            this.toastService.success({
              message:
                'A token has been sent to your email for verification. This token is valid for only 10 minutes'
            });
          }),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe({
          next: () => this.router.navigate(['/passkey']),
          error: () => {
            this.loadingService.hide();
          },
          complete: () => this.loadingService.hide()
        });
    }
  }
}
